;(function () {
  angular
    .module('contrast.application.dashboard')
    .controller('AppTagModalCtrl', AppTagModalCtrl)

  function AppTagModalCtrl(
    $scope,
    $uibModalInstance,
    TagService,
    AppTagModalService,
    applications,
    title
  ) {
    'ngInject'

    var appsId = _.map(applications, 'app_id')
    var originalTags = []

    angular.extend($scope, {
      applications: applications,
      title: title,
      has_tags: false,
      bulk_operation: false,
      taggingLabel: TagService.getTaggingLabel(),
      model: {
        tags: []
      }
    })

    angular.extend($scope, {
      ok: save,
      cancel: cancel,
      hasAvailableTags: hasAvailableTags,
      onTaggingSelect: TagService.onTaggingSelect.bind($scope, 'model.tags')
    })

    function init() {
      AppTagModalService.init(appsId, $scope, originalTags).then(function (
        response
      ) {
        $scope.availableTags = response.scopeAvailableTags
        originalTags = response.originalAppTags
        $scope.model.tags = response.scopeModelTags
        $scope.has_tags = response.scopeHasTags
        $scope.bulk_operation = response.scopeBulkOperation
      })
    }

    function save() {
      AppTagModalService.save(originalTags, $scope, appsId, $uibModalInstance)
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }

    function hasAvailableTags() {
      AppTagModalService.hasAvailableTags($scope)
    }

    init()
  }
})()
